import { BaseApi, type ItemResponse } from '@bv/api';
import { useUserStore } from '@bv/stores';
import type { CountryCode, CountryConfig } from '@bv/utils';

export interface Config {
  id?: string;
  name?: string;
  country_configs: Record<CountryCode, CountryConfig>;
  fallback_country: CountryCode;
  is_default?: boolean;
  created_at?: string;
  updated_at?: string;
}
/**
 * Manages API requests related to normalize.
 */
export class NormalizerApi extends BaseApi {
  /**
   * Initializes a new instance of the NormalizerApi.
   */
  public constructor() {
    super('freepbx-setting/normalizer-config');
  }

  public async config(): Promise<Config> {
    return this.request<{ config: Config }, ItemResponse<{ config: Config }>>({
      method: 'get',
      headers: { 'x-service-id': useUserStore().callCenterService?.id },
    }).then((data) => data.data.config);
  }
}

/**
 * A singleton instance of the NormalizerApi class for convenient access.
 */
export const normalizerApi: NormalizerApi = new NormalizerApi();
